import classNames from "classnames";
import Button from "components/core/Button/Button";
import React from "react";
import styles from "./PerksPageCTA.module.scss";

type Props = {
  title: string;
  description: string;
  buttonText: string;
  href?: string;
  onClick?: () => void;
  icon?: string;
};

const PerksPageCTA = (props: Props) => {
  return (
    <div className="container">
      <div className={styles.container}>
        <div className={styles.textContainer}>
          {props.icon && <img src={props.icon} className={styles.icon} />}
          <h3 className={styles.title}>{props.title}</h3>
          <p className={styles.details}>{props.description}</p>
        </div>
        <Button type="secondary" href={props.href} onClick={props.onClick}>
          {props.buttonText}
        </Button>
      </div>
    </div>
  );
};

export default PerksPageCTA;
